export const DICTIONARY_STORAGE_KEY = "selected-dictionary";
